import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './newsevent.css';

import Newsimg1 from '../../assets/COURSE PROMOTION.png';
import WSDimg from '../../assets/WSD1.jpg';
import WSDimg25 from '../../assets/wsd25-3.jpg';
import AGMimg from '../../assets/AGM1.jpg';
import CGTimg from '../../assets/CGT1.jpg';
import WSDOimg from '../../assets/WSDO.jpg';
import Aimg from '../../assets/aimg.jpg';
import Cimg from '../../assets/cimg.jpg';
import CRimg from '../../assets/crimg0.jpg';
import OPimg from '../../assets/opimg.jpg';
import OPimg00 from '../../assets/con1.jpg';
import NewsImgConvo from '../../assets/workshop nvq.png';
import NVQimg1 from '../../assets/nvqcolombo.jpg';


import Convoimg from '../../assets/bannerloc.jpg';
import Convoimg2 from '../../assets/course enrollment-extended.png';

const newsData = [



  // {
  //   title: "Admission Now Open !!!",
  //   date: "January, 2026",
  //   description: `🎓 January Intake Now Open – Enroll by November!

  //   ECI Campus is proud to announce its January academic intake, 
  //   offering aspiring professionals a gateway to globally recognized 
  //   optometry and orthoptics programs. With accreditation from TVEC 
  //   and affiliations with prestigious bodies such as the World Council 
  //   of Optometry, Asia Pacific Council of Optometry, and the Ceylon Council 
  //   of Optometry and Orthoptics, students are assured of a high-quality, 
  //   internationally aligned education.


  //   📌 Key Highlights:
  //   • Enroll by November to secure your place
  //   • Programs endorsed by leading optometric councils

  //   📞 For inquiries:
  //   Call: 011 268 2277 / 077 344 0937
  //   Email: ecinstitute@gmail.com
  //   Join a legacy of excellence. Your future in eye care begins here.`,

  //   images: [Newsimg1],
  //   link: "/registration-course", 
  // },


  
//   {
//     title: "Be Certified & Be Qualified,  NVQ Workshop",
//     date: "29th of March 2026",
// description: `Join for the Be Certified & Qualified workshop on NVQ Level 3 & 5 in Optometry at Nature Garden, Yakkala. Gain insights from Naresh Pradhan, Programme Director, on NVQ Optician (Ophthalmic), NVQ L5 – 6 Optometrist, and take part in an interactive Q & A session. Free registration, participation certificate, lunch, and tea break included. Contact Sadun (077 730 2592) or Lasantha (077 758 9353) to register today.`,

//     images: [NewsImgConvo],
     
//   },











// {
//   title: "ADMISSION EXTENDED - January 2026 Intake",
//   date: "15th of February, 2026",
//   description: `Eye Care Institute, 932, Maradana Road,Colombo 08`,
//   images: [Convoimg2],

// },


//     {
//     title: "DIYATHARIPPU - Eye Care 2026",
//     date: "25-26 January, 2026",
//     description: 
//       `
// 1st International Optometric Conference in Sri Lanka \n

// Theme: “Vision Beyond Borders – Advancing Global Eye Care” \n


// Join us at a historic milestone in Sri Lanka’s optometric journey.
// DIYATARIPPU- EYE CARE 2026 the 1st International Optometric Conference in Sri Lanka brings together global experts, practitioners, educators, and students to explore the latest developments in vision science, eye care technology, and interdisciplinary practice.
// This international gathering offers an exceptional platform for collaboration, learning, and leadership in eye health.
// Conference will cover free presentation, symposiums & hand on workshops I n the following areas:
// 	•	Clinical Optometry & Vision Therapy
// 	•	Advances in Optometric Research
// 	•	Pediatric & Geriatric Eye Care
// 	•	Public Health & Community Eye Services
// 	•	Low Vision & Rehabilitation
// 	•	Technology in Vision Science
// 	•	Interdisciplinary Eye Care Models
// 	•	Optometric Education & Professionalism
// `, 
//     images: [Convoimg],
//     link: "https://eyecare2026.com", 
//   },

];




const eventsData = [

  
        {
    title: "NVQ Workshop - Be Certified & Be Qualified",
    date: "Year: 2026",
    description: `Be Qualified • Be Certified, Phase 03 | @ Colombo | 26th April 2026 Successfully Completed! A heartfelt thank you to everyone who participated in our NVQ Level 3 & Level 5 Workshop. Your dedication and enthusiasm made this event a great success.`,
    images: [NVQimg1],
    link: "/nvqworkshop-colombo",
  },

        {
    title: "DIYATHARIPPU - EYE CARE 2026, 1st International Optometric Conference in Sri Lanka",
    date: "Year: 2026",
    description: "DIYATHARIPPU – EYE CARE 2026 proudly marks the 1st International Optometry Conference in Sri Lanka, bringing together optometrists, vision scientists, educators, researchers, and industry leaders from across the globe. Organized with the vision of advancing eye care standards, this landmark event serves as a dynamic platform for knowledge exchange, professional collaboration, and innovation in optometry and vision science. The conference will feature expert-led scientific sessions, keynote lectures, panel discussions, and interactive workshops focused on emerging trends, clinical excellence, research advancements, and global eye health challenges. DIYATHARIPPU – EYE CARE 2026 aims to inspire, connect, and empower eye care professionals while strengthening Sri Lanka’s presence in the international optometry community.",
    images: [OPimg00],
    link: "/diyatharippu-eyecare2026",
  },

      {
    title: "Orientation Programme",
    date: "Year: 2025",
    description: "We're pleased to announce the successful completion of our inspiring and informative orientation session hosted by the Eye Care Institute, College of Optometry & Vision Science in Sri Lanka. This special event welcomed our new students",
    images: [OPimg],
    link: "/orientation-programme-2025",
  },

      {
    title: "Career Guidance Programme",
    date: "Year: 2025",
    description: "Career Guidance Programme 2025, conducted by the Eye Care Institute, aimed to provide students with insights into career opportunities in the field of optometry and eye care.",
    images: [CRimg],
    link: "/careerguidance25",
  },

      {
    title: "World Sight Day",
    date: "Year: 2025",
    description: "World Sight Day 2025 was proudly celebrated by the Eye Care Institute, spotlighting the importance of eye health and the collective effort to prevent avoidable blindness",
    images: [WSDimg25],
    link: "/worldsightday25",
  },


    {
    title: "World Sight Day",
    date: "Year: 2024",
    description: "World Sight Day 2024, celebrated by the Eye Care Institute, focused on raising awareness about the importance of eye health and preventing avoidable blindness.",
    images: [WSDimg],
    link: "/worldsightday24",
  },
  {
    title: "Annual General Meeting (AGM)",
    date: "Year: 2024",
    description: "The AGM 2024 of the Eye Care Institute was a significant event bringing together staff, and partners to review the year's achievements and plan future initiatives.",
    images: [AGMimg],
    link: "/annualmeeting",
  },
  {
    title: "Eye Care - Awurudu Celebration",
    date: "Year: 2024",
    description: 
      `The Eye Care Institute proudly celebrated the Sinhala and Hindu New Year with great enthusiasm and joy. It was a wonderful occasion and honor the rich cultural heritage of our community.`,
    images: [Aimg],
    link: "/awurudu",
  },
  
  
  {
    title: "Eye Care - Cricket Fiesta",
    date: "Year: 2024",
    description: 
      `The Eye Care Institute's Cricket Fiesta 2024 was a smashing success. It was athrilling event and memorable celebration of teamwork and community spirit.`,
    images: [Cimg],
    link: "/cricket",
  },
  {
    title: "World Sight Day",
    date: "Year: 2023",
    description: "World Sight Day 2023, celebrated by the Eye Care Institute, focused on raising awareness about the importance of eye health and preventing avoidable blindness.",
    images: [WSDOimg],
    link: "/worldsightday23",
  },
  {
    title: "Eye Care - Christmas Get Together",
    date: "Year: 2023",
    description: "Celebrated the Christmas holiday with students, colleagues, and friends at the Eye Care Christmas Get Together.",
    images: [CGTimg],
    link: "/christmasgettogether",
  },

  
];

const NewsAndEvents = () => {
  return (
    <div className="container my-5">
      <h1 className="text-center mb-4">News and Events</h1> 
      <div className="row">
         {/* <h2 className="text-center mb-4">News</h2> */}

        {newsData.map((news, index) => (
          <div className="col-md-4 mb-4" key={index}>
            <div className="card">
              <img src={news.images[0]} className="card-img-top" alt={news.title} />
              <div className="card-body">
                
              <h5 className="card-title" style={{ textAlign: 'left' }}>{news.title}</h5>
              <h6 className="card-subtitle mb-2 text-muted" style={{ textAlign: 'left' }}>{news.date}</h6>
              <p
                className="card-text"
                style={{ whiteSpace: 'pre-line', textAlign: 'left' }}
              >
                {news.description}
              </p>


                {/* <p className="card-text">{news.description}</p> */}
                {news.link && <Link to={news.link} className="btn btn-primary">More Info</Link>}
              </div>
            </div>
          </div>
        ))}

        

        <h2 className="text-center mb-4">Events</h2>
        {eventsData.map((event, index) => (
          <div className="col-md-4 mb-4" key={index}>
            <div className="card">
              <img src={event.images[0]} className="card-img-top" alt={event.title} />
              <div className="card-body">
                <h5 className="card-title">{event.title}</h5>
                <h6 className="card-subtitle mb-2 text-muted">{event.date}</h6>
                <p className="card-text">{event.description}</p>
                {event.link && <Link to={event.link} className="btn btn-primary">Read More</Link>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewsAndEvents;
